import * as React from 'react'
import { Inset, Text, StackChildren, Colors } from '@doordash/design-language'
import OfferLetter from '../../organisms/offer-letter'
import { connect } from 'react-redux'
import * as actions from '../../../actions'
import t from './strings'
import Button from '@doordash/component-button'

type EmploymentOfferProps = {
  name: string
  uniqueLink: string
  onClick?: (uniqueLink: string, args: any) => Promise<any>
}

export const EmploymentOffer: React.FC<EmploymentOfferProps> = ({
  name,
  uniqueLink,
  onClick,
}) => (
  <Inset size={Inset.Sizes.Medium}>
    <StackChildren>
      <Text styles={Text.Styles.Bold24}>{t.title('California')}</Text>
      <Text styles={Text.Styles.Medium14} color={Colors.SystemGrey80}>
        {t.description(name)}
      </Text>
      <OfferLetter />
      <Button
        onClick={() => onClick(uniqueLink, { offerLetterSigned: true })}
        type={Button.Types.Primary}
      >
        {t.continue()}
      </Button>
    </StackChildren>
  </Inset>
)

EmploymentOffer.defaultProps = {
  name: '',
}

const mapDispatchToProps = {
  onClick: actions.updateDasherApplicant,
}

export default connect(null, mapDispatchToProps)(EmploymentOffer)
